(function ($) {
    jQuery(document).ready(function () {
        const $aside = jQuery('.aside-block.quick-links');
        if ($aside.length) {
            const links = [];
            jQuery('.page-content').find('section, .elementor-section, .elementor>.e-con, .elementor-section-wrap>.e-con').each(function () {
                const sectionId = jQuery(this).data('id');
                jQuery(this).find('h2,h3').each(function (index) {
                    if ($(this).length) {
                        $(this).attr('data-id', sectionId + '-' + index);
                        links.push({
                            text: $(this).text(),
                            id: sectionId + '-' + index,
                        });
                    }
                })

            });

            if (links.length > 1) {
                $aside.prepend(`<hr/>`);

                const icon = '<svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 22 22" fill="none"><path d="M19.6622 16C17.9331 18.989 14.7014 21 11 21C5.47715 21 1 16.5228 1 11C1 5.47715 5.47715 1 11 1C14.7014 1 17.9331 3.01099 19.6622 6M11.0001 7L7.00007 11M7.00007 11L11.0001 15M7.00007 11H21.0001" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>'
                for (let i = links.length - 1; i >= 0; i--) {
                    const link = links[i];
                    $aside.prepend(`<a href="${link.id}" class="page-section-link">${icon} ${link.text}</a>`);
                }

                $aside.on('click', '.page-section-link', function (e) {
                    e.preventDefault();
                    const id = jQuery(this).attr('href');
                    const $element = jQuery('[data-id="' + id + '"]');
                    if ($element.length) {
                        $('html').scrollTop($element.offset().top - 150);
                    }
                });
            }
        }
    });
})(jQuery);
